import { AudioRecorder } from './audio';
import { istGeraet } from './gleis';

/**
 * Bringt eine Datei vor dem Classic-Upload in das Format der alten Classic-App
 * (`docs/classic-rest-api.md` §7): SVG — Handschrift und Markierebene — als PNG, Ton als CAF.
 * Der Classic-Server und seine Auswertungen kennen weder SVG noch M4A (Vorgabe des Nutzers,
 * 2026-10-09). Alles andere geht unverändert.
 *
 * `null` heisst unverändert. Scheitert eine Umwandlung, wirft sie: lieber die Datei bleibt
 * offen und kommt beim nächsten Lauf wieder, als dass ein Format ankommt, das niemand öffnen kann.
 */
export async function wandleFuerClassic(
  base64: string,
  endung: string,
): Promise<{ base64: string; endung: string } | null> {
  if (endung === 'svg') return { base64: await svgZuPng(base64), endung: 'png' };
  if (endung === 'm4a' && istGeraet()) {
    const { base64: caf } = await AudioRecorder.zuCaf({ base64, endung });
    return { base64: caf, endung: 'caf' };
  }
  return null;
}

/** Längste Seite des PNG. Genug für den Ausdruck, klein genug für das WLAN einer Prüfung. */
const MAX_PX = 1600;

/** Ein SVG (Base64) als PNG (Base64), mit der Seitenlage aus seiner `viewBox`. */
async function svgZuPng(base64: string): Promise<string> {
  const text = atob(base64);
  const vb = /viewBox="\s*[-\d.]+[\s,]+[-\d.]+[\s,]+([\d.]+)[\s,]+([\d.]+)\s*"/.exec(text);
  const breite = vb ? Number(vb[1]) : 1;
  const hoehe = vb ? Number(vb[2]) : 1;
  const faktor = MAX_PX / Math.max(breite, hoehe, 1e-9);
  const w = Math.max(1, Math.round(breite * faktor));
  const h = Math.max(1, Math.round(hoehe * faktor));

  // Feste Grösse ins SVG schreiben: ohne `width`/`height` zeichnet WebKit es in 300×150.
  const mitGroesse = text.replace(/<svg\b/, '<svg width="' + w + '" height="' + h + '"');
  const bild = new Image();
  await new Promise<void>((fertig, fehler) => {
    bild.onload = () => fertig();
    bild.onerror = () => fehler(new Error('SVG lässt sich nicht zeichnen'));
    bild.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(mitGroesse);
  });
  const leinwand = document.createElement('canvas');
  leinwand.width = w;
  leinwand.height = h;
  const g = leinwand.getContext('2d');
  if (!g) throw new Error('Keine Leinwand');
  g.drawImage(bild, 0, 0, w, h);
  return leinwand.toDataURL('image/png').replace(/^data:image\/png;base64,/, '');
}
